const MODULE_NAME = 'PATIENT_VISITE';
const FETCH_STARTED = MODULE_NAME + 'FETCH_STARTED';
const FETCH_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';
const UPDATE_STARTED = MODULE_NAME + 'UPDATE_STARTED';
const UPDATE_COMPLETED = MODULE_NAME + 'UPDATE_COMPLETED';
const FETCH_ENTRIES_STARTED = MODULE_NAME + 'FETCH_ENTRIES_STARTED';
const FETCH_ENTRIES_COMPLETED = MODULE_NAME + 'FETCH_ENTRIES_COMPLETED';
const FETCH_ENTRIES_MEASUREMENTS_STARTED = MODULE_NAME + 'FETCH_ENTRIES_MEASUREMENTS_STARTED';
const FETCH_ENTRIES_MEASUREMENTS_COMPLETED = MODULE_NAME + 'FETCH_ENTRIES_MEASUREMENTS_COMPLETED';
const FETCH_ENTRIES_MEASUREMENTS_FAILED = MODULE_NAME + 'FETCH_ENTRIES_MEASUREMENTS_FAILED';
const REMOVE_VISITE_ENTRY_COMPLETED = MODULE_NAME + "REMOVE_VISITE_ENTRY_COMPLETED";

export {
  FETCH_STARTED,
  FETCH_COMPLETED,
  UPDATE_STARTED,
  UPDATE_COMPLETED,
  FETCH_ENTRIES_STARTED,
  FETCH_ENTRIES_COMPLETED,
  FETCH_ENTRIES_MEASUREMENTS_STARTED,
  FETCH_ENTRIES_MEASUREMENTS_COMPLETED,
  FETCH_ENTRIES_MEASUREMENTS_FAILED,
  REMOVE_VISITE_ENTRY_COMPLETED
};
